module.exports = __webpack_public_path__ + "aa1d457c661a7bde6b06e6fa3810ca8d.jpg";